import { apiClient } from '../provider/authProvider';

export const fetchOptions = async (subject, grade) => {
  let url = '/activity-options';
  if (subject) {
    url += `?subject_uuid=${subject}`;
  }
  if (subject && grade) {
    url += `&grade=${grade}`;
  }

  try {
    const response = await apiClient.get(url);
    return await response.data;
  } catch (error) {
    console.error('Error fetching options:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const fetchGrades = async () => {
  try {
    const response = await apiClient.get('/grades');
    return await response.data;
  } catch (error) {
    console.error('Error fetching options:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

// Function to fetch categories (or subjects in your case)
export const createCategory = async (name, subjectUUID, gradeUUID) => {
  try {
    const body = {
      name: name,
      subject_uuid: subjectUUID,
      grade_uuid: gradeUUID,
    }

    const response = await apiClient.post('/categories', body); // TODO use real id
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error creating category:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

// Function to fetch categories (or subjects in your case)
export const updateCategory = async (category_uuid, name, subjectUUID, gradeUUID) => {
  try {
    const body = {
      name: name,
      subject_uuid: subjectUUID,
      grade_uuid: gradeUUID,
    }

    const response = await apiClient.put(`/categories/${category_uuid}`, body);
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error updating category:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const fetchCategoryById = async (categoryId) => {
  try {
    const response = await apiClient.get(`/categories/${categoryId}`);
    return response.data; // Return the data for the specific activity
  } catch (error) {
    console.error('Error fetching category by ID:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const createSubject = async (name) => {
  try {
    const body = {
      name: name,
    }

    const response = await apiClient.post('/subjects', body);
    return response.data;
  } catch (error) {
    console.error('Error creating subject:', error.code);
    throw error;
  }
};

export const updateSubject = async (subject_uuid, name) => {
  try {
    const body = {
      name: name,
    }

    const response = await apiClient.put(`/subjects/${subject_uuid}`, body);
    return response.data;
  } catch (error) {
    console.error('Error updating subject:', error.code);
    throw error;
  }
};

// Function to fetch categories (or subjects in your case)
export const fetchSubjectCategories = async (favoritesOnly = false) => {
  try {
    const response = await apiClient.get(`/subject-categories`, {
      params: {
        favorites_only: favoritesOnly
      }
    });
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error fetching subjects:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const fetchSubjects = async () => {
  try {
    const response = await apiClient.get(`/subjects`);
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error fetching subjects:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const fetchCategories = async () => {
  try {
    const response = await apiClient.get(`/categories`);
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error fetching subjects:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const deleteSubject = async (subject_uuid) => {
  try {
    await apiClient.delete(`/subjects/${subject_uuid}`);
    return true;
  } catch (error) {
    console.error('Error deleting subject:', error.code);
    return false;
  }
};


export const deleteCategory = async (category_uuid) => {
  try {
    await apiClient.delete(`/categories/${category_uuid}`);
    return true;
  } catch (error) {
    console.error('Error deleting subject:', error.code);
    return false;
  }
};

// Function to fetch categories (or subjects in your case)
export const fetchCategoryActivities = async (categoryId, currentPage, itemsPerPage, searchTerm, difficulty, favoritesOnly = false) => {
  try {
    const response = await apiClient.get(`/categories/${categoryId}/activities`, {
      params: {
        page: currentPage,  // Example: Limit the number of activities
        limit: itemsPerPage,  // Example: Limit the number of activities
        search_term: searchTerm,
        difficulty: difficulty,
        favorites_only: favoritesOnly,
      }
    });
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error fetching subjects:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const uploadMultipartForm = async (formData) => {
  try {
    // Make the POST request with the form data
    const response = await apiClient.post(`/activities`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the correct content type for form uploads
      },
    });

    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error uploading form:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const editMultipartForm = async (formData, activityId) => {
  try {
    const response = await apiClient.put(`/activities/${activityId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the correct content type for form uploads
      },
    });

    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error editing form:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const updatePassword = async (oldPassword, repeatedNewPassword, newPassword) => {
  try {
    const body = {
      old_password: oldPassword,
      new_password: newPassword,
      repeated_new_password: repeatedNewPassword,
    }

    const response = await apiClient.put(`/passwords`, body);

    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error editing form:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

// Function to fetch a specific activity by its ID
export const fetchActivityById = async (activityId) => {
  try {
    const response = await apiClient.get(`/activities/${activityId}`);
    return response.data; // Return the data for the specific activity
  } catch (error) {
    console.error('Error fetching activity by ID:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const fetchActivityImage = async (url) => {
  try {
    const response = await apiClient.get(url, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching activity image:', error);
    throw error;
  }
};

export const deleteActivity = async (activityId) => {
  try {
    await apiClient.delete(`/activities/${activityId}`);
    return true;
  } catch (error) {
    console.error('Error deleting activity:', error);
    throw error;
  }
};



export const login = async (email, password) => {
  try {
    const body = {
      email: email,
      password: password,
    }

    const response = await apiClient.post('/login', body);
    return response.data;
  } catch (error) {
    console.error('Error during login:', error.code);
    throw error;
  }
};

export const createAccount = async (name, email, password, repeatedPassword) => {
  try {
    const body = {
      name: name,
      email: email,
      password: password,
      repeated_password: repeatedPassword,
    }

    const response = await apiClient.post('/accounts', body);
    return response.data;
  } catch (error) {
    console.error('Error during account creation:', error.code);
    throw error;
  }
};

export const requestPasswordReset = async (email) => {
  try {
    const body = {
      email: email,
    }

    const response = await apiClient.post('/password-resets/request', body);
    return response.data;
  } catch (error) {
    console.error('Error requesting password reset:', error.code);
    throw error;
  }
};

export const resetPassword = async (token, newPassword, repeatedNewPassword) => {
  try {
    const body = {
      token: token,
      new_password: newPassword,
      repeated_new_password: repeatedNewPassword,
    }

    const response = await apiClient.post('/password-resets/reset', body);
    return response.data;
  } catch (error) {
    console.error('Error resetting password:', error.code);
    throw error;
  }
};

export const activateAccount = async (token) => {
  try {
    const body = {
      token: token,
    }

    const response = await apiClient.post('/accounts/activate', body);
    return response.data;
  } catch (error) {
    console.error('Error activating account:', error.code);
    throw error;
  }
};

export const resendActivationEmail = async (email) => {
  try {
    const body = {
      email: email,
    }

    const response = await apiClient.post('/account-activations/resend', body);
    return response.data;
  } catch (error) {
    console.error('Error resending activation email:', error.code);
    throw error;
  }
};

// Function to fetch categories (or subjects in your case)
export const fetchSubjectCategoryCount = async (subject_uuid) => {
  try {
    const response = await apiClient.get(`/subjects/${subject_uuid}`); // TODO use real id
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error fetching subject category count:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const fetchMe = async () => {
  try {
    const response = await apiClient.get('/users/me');
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error fetching user info:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const updateMe = async (name) => {
  try {
    const body = {
      name: name,
    }

    const response = await apiClient.put('/users/me', body);
    return response.data; // Return the data from the API response
  } catch (error) {
    console.error('Error updating user info:', error.code);
    throw error; // Rethrow the error so it can be handled by the component
  }
};

export const addActivityToFavorites = async (activityId) => {
  try {
    const response = await apiClient.post(`/favorites/${activityId}`);
    return response.data;
  } catch (error) {
    console.error('Error adding activity to favorites:', error.code);
    throw error;
  }
};

export const removeActivityFromFavorites = async (activityId) => {
  try {
    const response = await apiClient.delete(`/favorites/${activityId}`);
    return response.data;
  } catch (error) {
    console.error('Error removing activity from favorites:', error.code);
    throw error;
  }
};

export const submitSurvey = async (answers, version = 'v1') => {
  try {
    const payload = {
      version,
      answers,
    };
    const response = await apiClient.post('/surveys', payload);
    return response.data;
  } catch (error) {
    console.error('Error submitting survey:', error);
    throw error;
  }
};

export const fetchWeeklies = async () => {
  try {
    const response = await apiClient.get('/weeklies');
    return response.data;
  } catch (error) {
    console.error('Error fetching weeklies:', error);
    throw error;
  }
};

export const fetchWeekly = async (week) => {
  try {
    const response = await apiClient.get(`/weeklies/${week}`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    console.error('Error fetching weekly:', error);
    throw error;
  }
};

export const saveWeekly = async (weeklyData) => {
  try {
    const response = await apiClient.post('/weeklies', weeklyData);
    return response.data;
  } catch (error) {
    console.error('Error saving weekly:', error);
    throw error;
  }
};

export const deleteWeekly = async (week) => {
  try {
    await apiClient.delete(`/weeklies/${week}`);
    return true;
  } catch (error) {
    console.error('Error deleting weekly:', error);
    throw error;
  }
};